/*!
 *  - webchirashi.js
 * @generated Thu Dec 15 2022 16:27:58 GMT+0900 (GMT+09:00)
 */
'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var pickupSlide = function pickupSlide() {
		if ($('.webchirashi-shufuchirashi-slide').length) {
			var contentBlock = $('.js-shufuchirashi-content-block');
			var contentBlockNone = $('.js-shufuchirashi-content-block-none');
			if ($('.webchirashi-shufuchirashi-slide li').length) {
				$('.webchirashi-shufuchirashi-slide').slick({
					autoplay: false,
					slidesToShow: 4,
					slidesToScroll: 1,
					loop: true,
					arrows: true,
					prevArrow: '<a class="slick-prev" href="#"><i class="icon icon-arrow_left"></i></a>',
					nextArrow: '<a class="slick-next" href="#"><i class="icon icon-arrow_right"></i></a>',
					responsive: [{
						breakpoint: 768,
						settings: {
							centerMode: true,
							slidesToShow: 1,
							arrows: false,
							dots: true
						}
					}]
				});
			}
		}
	};
	var blankCornerRemove = function blankCornerRemove() {
		if ($('.mod-anchor').length) {
			$('.mod-anchor-item').each(function (idx, val) {
				if (!$(val).find('a').length) {
					$(val).remove();
				}
			});
			$('.webchirashi-result-corner').each(function (idx, val) {
				if (!$(val).find('.webchirashi-result-item').length) {
					$(val).remove();
				}
			});
		}
	};
	// const resultAreaAccordion = () => {
	// 	let $areaList = $('.webchirashi-result-area-body').find('.cf_f_prefecture');
	// 	if ($areaList.length > 10) {
	// 		for (let i = 0; i < 10; i++) {
	// 			$areaList.eq(i).addClass(v);
	// 		}
	// 		$('.webchirashi-result-area-more').addClass(a);
	// 		$('.webchirashi-result-area-more').on('click', () => {
	// 			for (let i = 10; i < $areaList.length; i++) {
	// 				$areaList.eq(i).addClass(v);
	// 			}
	// 			$('.webchirashi-result-area-more').removeClass(a);
	// 		});
	// 	} else {
	// 		for (let i = 0; i < $areaList.length; i++) {
	// 			$areaList.eq(i).addClass(v);
	// 		}
	// 	}
	// };
	// const excludedStore = () => {
	// 	const getJSONexcludedStore = () => {
	// 		if (FUNCTIONS.va.pathname.split('/')[3] === 'detail') { // 詳細
	// 			let flyerKey = FUNCTIONS.va.pathname.split('/')[4].replace(/\.html/, '');
	// 			if (flyerKey) {
	// 				return $.getJSON(`/ajax/flyer/${flyerKey}.json`);
	// 			} else {
	// 				$('.webchirashi-result-excludedStore').remove();
	// 			}
	// 		} else { // 地域
	// 			let flyerKey = $('.rt_cf_f_flyer_id').text();
	// 			let prefID = $('.rt_cf_p_prefecture').text();
	// 			if (flyerKey && prefID) {
	// 				return $.getJSON(`/ajax/flyer/${prefID}/${flyerKey}.json`);
	// 			} else {
	// 				$('.webchirashi-result-excludedStore').remove();
	// 			}
	// 		}
	// 	};

	// 	getJSONexcludedStore().then((data) => {
	// 		if (data.rt_bn_flyer_headding_line.length) {
	// 			if (data.rt_bn_flyer_headding_line[0].cf_f_excluded_store !== null) {
	// 				const dataList = data.rt_bn_flyer_headding_line[0].cf_f_excluded_store;
	// 				let adjustList = {};

	// 				// 都道府県ごとの配列に整形
	// 				for (let i = 0; i < dataList.length; i++) {
	// 					let prefCode = Number(dataList[i].cf_s_prefecture_code);
	// 					prefCode = String(prefCode);
	// 					if (!adjustList[prefCode]) {
	// 						adjustList[prefCode] = [];
	// 						if (dataList[i].cf_s_status === '1') {
	// 							adjustList[prefCode].push(dataList[i]);
	// 						}
	// 					} else {
	// 						if (dataList[i].cf_s_status === '1') {
	// 							adjustList[prefCode].push(dataList[i]);
	// 						}
	// 					}
	// 				}
	// 				// console.dir(adjustList);

	// 				let appendHTML = '';
	// 				Object.keys(adjustList).forEach((key) => {
	// 					// orderの昇順にソート
	// 					adjustList[key].sort((adjustLista, adjustListb) => {
	// 						if (adjustLista.cf_s_order < adjustListb.cf_s_order) return -1;
	// 						if (adjustLista.cf_s_order > adjustListb.cf_s_order) return 1;
	// 						return 0;
	// 					});

	// 					appendHTML += `<tr><th class="width-u-20 width-md-100">${adjustList[key][0].cf_s_prefecture}</th>` +
	// 					'<td><ul class="ul-disc pure-g">';

	// 					for (let i = 0; i < adjustList[key].length; i++) {
	// 						appendHTML += `<li class="pure-u-1-4 pure-u-lg-1-3 pure-u-md-1-2">${adjustList[key][i].cf_s_shop_name}</li>`;
	// 					}
	// 					appendHTML += '</ul></td></tr>';
	// 				});

	// 				$('.js-excludedStore').append(appendHTML);
	// 			} else {
	// 				$('.webchirashi-result-excludedStore').remove();
	// 			}
	// 		} else {
	// 			$('.webchirashi-result-excludedStore').remove();
	// 		}
	// 	});
	// };
	// const webchirashiSearch = () => {
	// 	if ($('.js-webchirashi-search-shop').length) {
	// 		const areaSelect = $('.js-webchirashi-search-area');
	// 		const shopSelect = $('.js-webchirashi-search-shop');
	// 		const searchBtn = $('.js-webchirashi-search-btn');
	// 		let dataList, itemdata;
	// 		// 県名一覧
	// 		const getJSONprefecture = () => {
	// 			return $.getJSON('/ajax/shop/prefecture.json');
	// 		};
	// 		const getJSONBrand = (_area) => {
	// 			return $.getJSON(`/ajax/flyer/prefecture/${_area}.json`);
	// 		};
	// 		const setJSONBrand = (_area, _brand) => {
	// 			areaSelect.css('pointer-events', 'none');
	// 			shopSelect.css('pointer-events', 'none');
	// 			$('.js-webchirashi-search-shop option').remove();
	// 			shopSelect.append($('<option>').html('選択してください').val(''));
	// 			getJSONBrand(_area).done((data) => {
	// 				dataList = data.rt_bn_store_pre;
	// 				for (let i = 0; i < dataList.length; i++) {
	// 					if (!((dataList[i]._key === 'homac_nicot') || (dataList[i]._key === 'hodaka'))) {
	// 						if (_brand === dataList[i]._key) {
	// 							shopSelect.append($('<option>').html(dataList[i].cf_sb_name).val(dataList[i]._key).prop('selected', true));
	// 						} else {
	// 							shopSelect.append($('<option>').html(dataList[i].cf_sb_name).val(dataList[i]._key));
	// 						}
	// 					}
	// 				}
	// 				areaSelect.css('pointer-events', 'auto');
	// 				shopSelect.css('pointer-events', 'auto');
	// 			});
	// 		};
	// 		// 県名表示
	// 		areaSelect.css('pointer-events', 'none');
	// 		shopSelect.css('pointer-events', 'none');
	// 		$('.js-webchirashi-search-area option').remove();
	// 		areaSelect.append($('<option>').html('選択してください').val(''));
	// 		getJSONprefecture().done((data) => {
	// 			// リストから重複を削除
	// 			let list = data.rt_bn_store_list;
	// 			let clearList = list.filter(function(v1, i1, a1){
	// 				return (a1.findIndex(function(v2){ return (v1.cf_s_prefecture===v2.cf_s_prefecture) }) === i1);
	// 			});
	// 			// optionセット
	// 			for(let i = 0; i < clearList.length; i++) {
	// 				if(!(location.pathname.split('/')[2].match('.html') || location.pathname.split('/')[2] === '')) {
	// 					if($('.js-webchirashi-shop-area').text() === clearList[i].cf_s_prefecture_code) {
	// 						areaSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code).prop('selected', true));
	// 					} else {
	// 						areaSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code));
	// 					}
	// 				} else {
	// 					// チラシトップ用・ローカルストレージに検索ページ情報があれば
	// 					if (localStorage.getItem('webchirashiItem02')) {
	// 						itemdata = JSON.parse(localStorage.getItem('webchirashiItem02'));
	// 						if(itemdata.area === clearList[i].cf_s_prefecture_code) {
	// 							areaSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code).prop('selected', true));
	// 						} else {
	// 							areaSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code));
	// 						}
	// 					} else {
	// 						areaSelect.append($('<option>').html(clearList[i].cf_s_prefecture).val(clearList[i].cf_s_prefecture_code));
	// 					}
	// 				}
	// 			}
	// 			areaSelect.css('pointer-events', 'auto');
	// 			shopSelect.css('pointer-events', 'auto');
	// 		});
	// 		// 詳細・一覧ページ用
	// 		if(!(location.pathname.split('/')[2].match('.html') || location.pathname.split('/')[2] === '')) {
	// 			// areaSelect.val($('.js-webchirashi-shop-area').text());
	// 			setJSONBrand($('.js-webchirashi-shop-area').text(), $('.js-webchirashi-shop-brand').text());
	// 		} else {
	// 			// チラシトップ用・ローカルストレージに検索ページ情報があれば
	// 			if (localStorage.getItem('webchirashiItem02')) {
	// 				itemdata = JSON.parse(localStorage.getItem('webchirashiItem02'));
	// 				// areaSelect.val(itemdata.area);
	// 				setJSONBrand(itemdata.area, itemdata.shop);
	// 			}
	// 		}
	// 		areaSelect.change(function(){
	// 			let areaVal = $(this).val();
	// 			setJSONBrand(areaVal, null);
	// 		});
	// 		shopSelect.eq(0).parent('label').on('click', () => {
	// 			if (!(areaSelect.val())) {
	// 				alert('都道府県を選択してください');
	// 			}
	// 		});
	// 		$(function(){
	// 			// ローカルストレージに検索したページ情報を追加
	// 			const setLocalstrageWebchirashi = () => {
	// 				if (localStorage.getItem('webchirashiItem02')) {
	// 					localStorage.removeItem('webchirashiItem02');
	// 				}
	// 				let webchirashiItem02Val = {
	// 					area: areaSelect.val(),
	// 					shop: shopSelect.val()
	// 				};
	// 				localStorage.setItem('webchirashiItem02', JSON.stringify(webchirashiItem02Val));
	// 			};
	// 			searchBtn.on('click', () => {
	// 				if (!(areaSelect.val())) {
	// 					alert('都道府県を選択してください');
	// 				} else if (!(shopSelect.val())) {
	// 					alert('店舗を選択してください');
	// 				} else {
	// 					setLocalstrageWebchirashi();
	// 					window.location.href = '/dcm-webchirashi/'+shopSelect.val()+'/'+areaSelect.val()+'/';
	// 				}
	// 			});
	// 		});
	// 	}
	// };
	// const webchirashiTagChange = () => {
	// 	if ($('.webchirashi-result-area').length) {
	// 		let tagtext = $('.webchirashi-result-area li');
	// 		for (let i = 0; i < tagtext.length; i++) {
	// 			if (tagtext.eq(i).text() === '01') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'北海道'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '02') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'青森県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '03') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'岩手県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '04') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'宮城県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '05') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'秋田県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '06') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'山形県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '07') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'福島県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '08') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'茨城県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '09') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'栃木県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '10') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'群馬県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '11') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'埼玉県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '12') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'千葉県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '13') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'東京都'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '14') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'神奈川県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '15') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'新潟県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '16') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'富山県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '17') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'石川県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '18') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'福井県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '19') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'山梨県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '20') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'長野県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '21') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'岐阜県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '22') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'静岡県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '23') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'愛知県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '24') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'三重県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '25') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'滋賀県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '26') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'京都府'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '27') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'大阪府'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '28') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'兵庫県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '29') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'奈良県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '30') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'和歌山県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '31') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'鳥取県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '32') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'島根県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '33') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'岡山県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '34') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'広島県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '35') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'山口県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '36') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'徳島県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '37') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'香川県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '38') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'愛媛県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '39') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'高知県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '40') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'福岡県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '41') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'佐賀県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '42') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'長崎県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '43') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'熊本県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '44') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'大分県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '45') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'宮崎県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '46') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'鹿児島県'+
	// 				'</a>');
	// 			} else if (tagtext.eq(i).text() === '47') {
	// 				tagtext.eq(i).html('<a href="/dcm-webchirashi/'+location.pathname.split('/')[2]+'/'+tagtext.eq(i).text()+'/">'+
	// 					'沖縄県'+
	// 				'</a>');
	// 			}
	// 		}
	// 	}
	// };
	var matchHeightPrice = function matchHeightPrice() {
		$('.webchirashi-result-item').each(function (idx, val) {
			if ($(val).find('.webchirashi-result-item-bandle').length) {
				$(val).find('.webchirashi-result-item-price').removeClass('mh-price');
			}
		});
		$('.mh-price').matchHeight();
	};
	var memoFixed = function memoFixed() {
		if ($('.js-webvhirashi-memo').length) {
			var memo = $('.js-webvhirashi-memo');
			var main = $('.js-webvhirashi-main');

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var mainPos = main.offset().top;
				var thisScroll = $this.scrollTop();

				if (FUNCTIONS.va.window.width < 1025) {
					mainPos -= 60;
				} else {
					mainPos -= 68;
				}

				if (thisScroll > mainPos) {
					memo.addClass(f);
				} else {
					memo.removeClass(f);
				}
			});
		}
	};
	var memoaddFavList = function memoaddFavList() {
		// 選択されたチラシの商品データ
		var getmemoItem = function getmemoItem(_shopId, _kanriId) {
			return $.getJSON('/ajax/dcm-webchirashi/' + _shopId + '/detail/' + _kanriId + '.json');
		};
		// 選択されたチラシの店舗名
		var getmemoItemShop = function getmemoItemShop(_shopId) {
			return $.getJSON('/ajax/dcm-webchirashi/' + _shopId + '.json');
		};
		if ($('.js-dcm-webshirashi-memo-list').length) {
			var addBlock = $('.js-dcm-webshirashi-memo-list'),
			    i = void 0,
			    l = void 0;
			var favoStorage = [];
			var favArr = [];

			for (i in localStorage) {
				if (i.indexOf('memoFavItem--') !== -1) {
					favoStorage.push(i);
				}
			}
			for (i = 0; i < favoStorage.length; i++) {
				var idlist = favoStorage[i].split('--');
				var hash = {
					shopId: idlist[1],
					kanriId: idlist[2],
					datetime: localStorage[favoStorage[i]]
				};
				favArr.push(hash);
			}
			// itemArray配列に、jsonの内容を格納
			var itemArray = [];
			var favItemList = new Promise(function (resolve) {
				var items = void 0;
				var count = 0;
				for (i = 0; i < favArr.length; i++) {
					$.when(getmemoItem(favArr[i].shopId, favArr[i].kanriId), getmemoItemShop(favArr[i].shopId)).then(function (data, dataShop) {
						console.log(data[0].rt_bn_flyer_data[0], dataShop[0].rt_bn_shop_data[0]);
						items = {
							shopid: dataShop[0].rt_bn_shop_data[0]._key,
							shop: dataShop[0].rt_bn_shop_data[0].cf_s_shop_name_abbreviation,
							shoplink: data[0].rt_bn_flyer_data[0].rt_detail_url,
							kanriid: data[0].rt_bn_flyer_data[0]._key,
							img: data[0].rt_bn_flyer_data[0].cf_f_product_image,
							alt: data[0].rt_bn_flyer_data[0].cf_f_product_name,
							brandName: data[0].rt_bn_flyer_data[0].cf_f_manufacturer,
							productName: data[0].rt_bn_flyer_data[0].cf_f_product_name,
							partNumber: data[0].rt_bn_flyer_data[0].cf_f_part_number,
							color: data[0].rt_bn_flyer_data[0].cf_f_color,
							size: data[0].rt_bn_flyer_data[0].cf_f_size,
							capacity: data[0].rt_bn_flyer_data[0].cf_f_capacity,
							onlineshoplink: data[0].rt_bn_flyer_data[0].cf_f_link_url,
							flag: data[0].rt_bn_flyer_data[0].cf_f_division, //目玉
							price_intax: data[0].rt_bn_flyer_data[0].cf_f_price_intax, //価格（税込）
							price_outtax: data[0].rt_bn_flyer_data[0].cf_f_price_outtax, //価格（税抜）
							bundle_standard: data[0].rt_bn_flyer_data[0].cf_f_bundle_standard, //バンドル規格（よりどり2点で）
							bundle_price_outtax: data[0].rt_bn_flyer_data[0].cf_f_bundle_price_outtax, //バンドル価格（税抜）
							bundle_price_intax: data[0].rt_bn_flyer_data[0].cf_f_bundle_price_intax, //バンドル価格（税込）
							price_per_point_outtax_prefix: data[0].rt_bn_flyer_data[0].cf_f_price_per_point_outtax_prefix, //1点あたり価格（税抜）接頭語
							price_per_point_outtax: data[0].rt_bn_flyer_data[0].cf_f_price_per_point_outtax, //1点あたり価格（税抜）
							price_per_point_intax_prefix: data[0].rt_bn_flyer_data[0].cf_f_price_per_point_intax_prefix, //1点あたり価格（税込）接頭語
							price_per_point_intax: data[0].rt_bn_flyer_data[0].cf_f_price_per_point_intax, //1点あたり価格（税込）
							event_end: data[0].rt_bn_flyer_data[0].cf_f_event_end //イベント終了日時
						};
						itemArray.push(items);
						count++;
						if (count === favArr.length) {
							return resolve(itemArray);
						}
					});
				}
			});
			Promise.all([favItemList]).then(function () {
				// itemArray配列に時間を追加
				for (i = 0; i < favArr.length; i++) {
					for (l = 0; l < itemArray.length; l++) {
						if (favArr[i].name === 'memoFavItem-' + itemArray[l].id) {
							itemArray[l].datatime = favArr[i].datetime;
						}
					}
				}
				// 降順ソート
				itemArray.sort(function (sorta, sortb) {
					return sorta.datatime < sortb.datatime ? 1 : -1;
				});
				// 描画
				for (i = 0; i < favArr.length; i++) {
					if (i < 20) {
						var itemImg = void 0;
						var itemDate = new Date(itemArray[i].event_end);
						var nowDate = new Date();
						// console.log("itemDate < nowDate = " + (itemDate < nowDate));
						if (itemDate < nowDate) {
							itemImg = '<figure class="webchirashi-result-item-img">' + '<div class="webchirashi-result-item-img-inner __enditem">' + '<img src="/flyer_file/file/' + itemArray[i].img + '" alt="' + itemArray[i].alt + '" class="">' + '<span class="">掲載終了<span>' + '</div>' + '</figure>';
						} else {
							itemImg = '<figure class="webchirashi-result-item-img">' + '<div class="webchirashi-result-item-img-inner">' + '<img src="/flyer_file/file/' + itemArray[i].img + '" alt="' + itemArray[i].alt + '" class="">' + '</div>' + '</figure>';
						}
						var onlineBtn = void 0;
						if (!itemArray[i].onlineshoplink) {
							onlineBtn = "";
						} else {
							onlineBtn = '<div class="webchirashi-result-item-btn">' + '<a href="' + itemArray[i].onlineshoplink + '" target="_blank" class="mod-btn mod-btn_right opacity">' + 'オンラインショップで購入<i class="icon icon-blank"></i>' + '</a>' + '</div>';
						}
						var outtax = void 0;
						var bandole = void 0;
						if (!itemArray[i].flag === '目玉') {
							if (!itemArray[i].bundle_standard) {
								outtax = '<p class="fw_bold"><span class="fs_50">' + itemArray[i].price_outtax + '</span>円</p>';
								bandole = '';
							} else {
								outtax = '<p class=""><span class="fs_50">' + itemArray[i].price_outtax + '</span>円</p>';
								bandole = '<div class="webchirashi-result-item-bandle mh-price">' + '<div class="">' + '<p class="ta_center">' + itemArray[i].bundle_standard + '</p>' + '<div class="webchirashi-result-item-bandle-price">' + '<p class="fw_bold"><span class="fs_26">' + itemArray[i].bundle_price_outtax + '</span>円</p>' + '<p class="fw_bold">（税込 <span class="">' + itemArray[i].bundle_price_intax + '</span>円）</p>' + '</div>' + '</div>' + '<div class="">' + '<p class="ta_center">1点あたり</p>' + '<div class="webchirashi-result-item-bandle-price fw_bold">' + '<p><span class="">' + itemArray[i].price_per_point_outtax_prefix + '</span><span class="fs_26">' + itemArray[i].price_per_point_outtax + '</span>円</p>' + '<p>（税込 <span class="">' + itemArray[i].price_per_point_intax_prefix + '</span><span class="">' + itemArray[i].price_per_point_intax + '</span>円）</p>' + '</div>' + '</div>' + '</div>';
							}
						} else {
							if (!itemArray[i].bundle_standard) {
								outtax = '<p class="fw_bold color_red"><span class="fs_50">' + itemArray[i].price_outtax + '</span>円</p>';
								bandole = '';
							} else {
								outtax = '<p class="fw_bold color_red"><span class="fs_50">' + itemArray[i].price_outtax + '</span>円</p>';
								bandole = '<div class="webchirashi-result-item-bandle mh-price">' + '<div class="">' + '<p class="ta_center">' + itemArray[i].bundle_standard + '</p>' + '<div class="webchirashi-result-item-bandle-price">' + '<p class="fw_bold color_red"><span class="fs_26">' + itemArray[i].bundle_price_outtax + '</span>円</p>' + '<p class="fw_bold">（税込 <span class="">' + itemArray[i].bundle_price_intax + '</span>円）</p>' + '</div>' + '</div>' + '<div class="">' + '<p class="ta_center">1点あたり</p>' + '<div class="webchirashi-result-item-bandle-price fw_bold">' + '<p><span class="">' + itemArray[i].price_per_point_outtax_prefix + '</span><span class="fs_26">' + itemArray[i].price_per_point_outtax + '</span>円</p>' + '<p>（税込 <span class="">' + itemArray[i].price_per_point_intax_prefix + '</span><span class="">' + itemArray[i].price_per_point_intax + '</span>円）</p>' + '</div>' + '</div>' + '</div>';
							}
						}
						addBlock.append('<li class="js-dcm-webshirashi-memo-list-item webchirashi-result-item pure-u-1-4 pure-u-lg-1-2 pure-u-md-1 space-u-40-child">' + '<div class="webchirashi-result-item-inner">' + itemImg + '<div class="opacity"><a href="' + itemArray[i].shoplink + '" class="mod-newsItem-label mt20">' + itemArray[i].shop + '</a></div>' + '<div class="webchirashi-result-item-text __bd_none">' + '<button type="button" class="webchirashi-result-item-fav opacity is-fav">' + '<div class="di_none">' + '店舗ID<span class="js-dcm-webchirashi-shopId">' + itemArray[i].shopid + '</span>' + '管理ID<span class="js-dcm-webchirashi-kanriId">' + itemArray[i].kanriid + '</span>' + '</div>' + '<i class="icon icon-fav"></i>' + '<div class="webchirashi-result-item-name">' + '<p class="fw_bold">' + itemArray[i].brandName + '</p>' + '<p class="">' + itemArray[i].productName + '</p>' + '<p class="">' + itemArray[i].partNumber + '</p>' + '</div>' + '<p class="webchirashi-result-item-info" data-mh="itemInfo">' + '<span class="">' + itemArray[i].color + '</span>' + '<span class="">' + itemArray[i].size + '</span>' + '<span class="">' + itemArray[i].capacity + '</span>' + '</p>' + bandole + '<div class="webchirashi-result-item-price">' + '<div class="webchirashi-result-item-price-inner">' + outtax + '<p class="fs_md_12">（税込 <span class="">' + itemArray[i].price_intax + '</span>円）</p>' + '</div>' + '</div>' + '</button>' + onlineBtn + '</div>' + '</div>' + '</li>');
					}
				}
				// マッチハイト
				$('.webchirashi-result-item-name').matchHeight();
				$('.webchirashi-result-item-info').matchHeight();
			});
			// 描画後
			$(function () {
				// お気に入り削除・ブロックごと削除用
				$(document).on('click', '.webchirashi-result-item-fav', function () {
					localStorage.removeItem('memoFavItem--' + $(this).find('.js-dcm-webchirashi-shopId').text() + '--' + $(this).find('.js-dcm-webchirashi-kanriId').text());
					$(this).parents('.js-dcm-webshirashi-memo-list-item').remove();
				});
			});
		}
	};
	// メモお気に入りボタン
	var memofavClick = function memofavClick() {
		var favBtn = $('.webchirashi-result-item-fav');
		var shopId = void 0,
		    kanriId = void 0,
		    i = void 0;
		// すでにお気に入り追加されているitemをアクティブに
		for (i = 0; i < favBtn.length; i++) {
			shopId = favBtn.eq(i).find('.js-dcm-webchirashi-shopId').text();
			kanriId = favBtn.eq(i).find('.js-dcm-webchirashi-kanriId').text();
			if (localStorage.getItem('memoFavItem--' + shopId + '--' + kanriId)) {
				favBtn.eq(i).addClass('is-fav');
			}
		}
		// お気に入り追加・削除
		favBtn.on('click', function () {
			shopId = $(this).find('.js-dcm-webchirashi-shopId').text();
			kanriId = $(this).find('.js-dcm-webchirashi-kanriId').text();
			if (!$(this).hasClass('is-fav')) {
				$(this).addClass('is-fav');
				var favoDatetime = new Date();
				localStorage.setItem('memoFavItem--' + shopId + '--' + kanriId, favoDatetime);
			} else {
				$(this).removeClass('is-fav');
				localStorage.removeItem('memoFavItem--' + shopId + '--' + kanriId);
			}
		});
	};

	memoFixed();
	pickupSlide();
	// webchirashiSearch();
	matchHeightPrice();
	blankCornerRemove();
	// webchirashiTagChange();
	// if(FUNCTIONS.va.window.width <= 768) {
	// 	resultAreaAccordion();
	// }
	// if ($('.webchirashi-result-excludedStore').length) {
	// 	excludedStore();
	// }
	memoaddFavList();
	memofavClick();
})(window.jQuery, window.FUNCTIONS);

// ブラウザバックリロード
// window.onpageshow = function(event){
// 	if (event.persisted) {
// 		window.location.reload();
// 	}
// };
$(window).on('load', function () {
	var pickupSlideonload = function pickupSlideonload() {
		if ($('.webchirashi-pickup-slide').length) {
			var contentBlock = $('.js-webchirashi-content-block');
			var contentBlockNone = $('.js-webchirashi-content-block-none');
			if ($('.webchirashi-pickup-slide li').length) {
				$('.webchirashi-pickup-slide').slick({
					autoplay: false,
					slidesToShow: 4,
					slidesToScroll: 1,
					loop: true,
					arrows: true,
					prevArrow: '<a class="slick-prev" href="#"><i class="icon icon-arrow_left"></i></a>',
					nextArrow: '<a class="slick-next" href="#"><i class="icon icon-arrow_right"></i></a>',
					responsive: [{
						breakpoint: 768,
						settings: {
							centerMode: true,
							slidesToShow: 1,
							arrows: false,
							dots: true
						}
					}]
				});
				// コンテンツ表示
				contentBlock.addClass('is-active');
				console.log("ab");
				// 折り込みチラシなければ非表示
				if (!$('.webchirashi-shufuchirashi').find('.shufoo-list-parent').find('ul').length) {
					$('.webchirashi-shufuchirashi').addClass('di_none');
				}
			} else {
				// 折り込みチラシがあればそこだけ表示
				if (!$('.webchirashi-shufuchirashi').find('.shufoo-list-parent').find('ul').length) {
					contentBlockNone.addClass('is-active');
				} else {
					contentBlock.addClass('is-active');
					$('.webchirashi-pickup-slideWrap').addClass('di_none');
					if (!$('.webchirashi-result .li').length) {
						$('.webchirashi-result').addClass('di_none');
						contentBlock.addClass('color-bg_white');
					}
				}
			}
		}
	};
	pickupSlideonload();
});